// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WEpg6{display:flex;flex-direction:column;list-style:none;padding:0;margin:0}.FDdMM{gap:4px}.EeeiF{gap:8px}.PI0BQ{gap:12px}.cyTGw{display:flex;flex-direction:row;align-items:center}.YQfT7{display:inline-block;flex-shrink:0}.tmDFl{width:4px;height:4px}.yoKyK{width:6px;height:6px}.jcWlb{width:8px;height:8px}.ZRlT9{background-color:currentColor;border-radius:50%}.oIrZ1{border:1.5px solid currentColor;border-radius:50%;background:transparent}.NzjmS{background-color:currentColor;border-radius:0}.bhKlR{background-color:currentColor;border-radius:0;width:8px;height:2px}.zJNaE{margin-right:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `WEpg6`,
	"compact": `FDdMM`,
	"default": `EeeiF`,
	"relaxed": `PI0BQ`,
	"item": `cyTGw`,
	"bullet": `YQfT7`,
	"bulletSmall": `tmDFl`,
	"bulletDefault": `yoKyK`,
	"bulletLarge": `jcWlb`,
	"disc": `ZRlT9`,
	"circle": `oIrZ1`,
	"square": `NzjmS`,
	"dash": `bhKlR`,
	"bulletMargin": `zJNaE`
};
export default ___CSS_LOADER_EXPORT___;
